/**
 * Fires an event so the `useLocalStorage` hook from the `usehooks-ts` library can trigger. This is not an event used normally by the browser
 */
export function dispatchLocalStorageUpdatedEvent() {
  window.dispatchEvent(new Event('local-storage'));
}
